import { APP_MODE, ROLES, SUBSCRIPTION_PLANS } from '../../utils/constant'
import Icon from '../icon'

export const sideBarItemsList = [
  {
    title: 'Home',
    path: '/',
    icon: <Icon icon={'ant-design:home-filled'} />,
    modeIncluded: [APP_MODE.HIRING, APP_MODE.LEARNER]
  },
  {
    title: 'Courses',
    path: '/courses',
    icon: <Icon icon={'dashicons:welcome-learn-more'} />,
    rolesExcluded: [ROLES.DEVELOPER, ROLES.LEARNER]
  },
  {
    title: 'Courses',
    path: '/learning/courses',
    icon: <Icon icon={'dashicons:welcome-learn-more'} />,
    modeIncluded: [APP_MODE.LEARNER]
  },
  {
    title: 'Challenges',
    path: '/challenges',
    icon: <Icon icon="material-symbols-light:swords-rounded" />
  },
  {
    title: 'Contests',
    path: '/contests',
    icon: <Icon icon="solar:cup-bold" />,
    rolesExcluded: [ROLES.DEVELOPER]
  },
  {
    title: 'Assessments',
    path: '/assessments',
    icon: <Icon icon="ic:outline-assessment" />,
    rolesExcluded: [ROLES.DEVELOPER]
  },
  {
    title: 'Settings',
    path: '/settings',
    icon: <Icon icon="ph:gear-fill" />,
    subItems: [
      {
        title: 'Profile',
        path: '/settings/profile',
        icon: <Icon icon="iconamoon:profile-circle-fill" />,
        modeIncluded: [APP_MODE.HIRING, APP_MODE.LEARNER]
      },
      {
        title: 'Users',
        path: '/settings/users',
        roles: [ROLES.ADMIN],
        icon: <Icon icon="flowbite:users-solid" />
      },
      {
        title: 'Configurations',
        path: '/settings/config',
        roles: [ROLES.ADMIN],
        icon: <Icon icon="icon-park-outline:setting-config" />,
        plans: [SUBSCRIPTION_PLANS.ENTERPRISE]
      },
      {
        title: 'Workspaces',
        path: '/settings/workspaces',
        icon: <Icon icon="bi:person-workspace" />,
        roles: [ROLES.ADMIN],
        plans: [SUBSCRIPTION_PLANS.ENTERPRISE]
      }
    ]
  },
  {
    title: 'Tenants',
    path: '/tenant-manager',
    icon: <Icon icon={'fa6-solid:users-gear'} fontSize={'1.2em'} />,
    roles: [ROLES.DEVELOPER],
    allowAdmin: false // to support change in the checkUserAccess function
  },
  {
    title: 'Blacklisted Domains',
    path: '/blacklisted-domain',
    icon: <Icon icon={'mdi:domain-off'} />,
    roles: [ROLES.DEVELOPER],
    allowAdmin: false
  },
  {
    title: 'Databases',
    path: '/databases',
    icon: <Icon icon="material-symbols:database" fontSize={'1.55em'} />,
    rolesExcluded: [ROLES.DEVELOPER]
  },
  {
    title: 'MCQs Question Bank',
    path: '/question-bank-management',
    icon: <Icon icon="fluent:book-question-mark-24-filled" />
  }
]
